/* Copyright 2022 SIB Visions GmbH
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not
 * use this file except in compliance with the License. You may obtain a copy of
 * the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the
 * License for the specific language governing permissions and limitations under
 * the License.
 */

/**
 * Returns the mapped className of an icon based on the received icon-name
 * @param icon  
 */
export function convertIcon(icon:string) {
    switch (icon) {
        case 'glass':
            return "fas fa-glass-martini";
      
        case 'music':
            return "fas fa-music";
    
        case 'search':
            return "fas fa-search";
    
        case 'envelope-o':
        return "far fa-envelope";
    
        case 'heart':
        return "fas fa-heart";
    
        case 'star':
        return "fas fa-star";
    
        case 'star-o':
        return "far fa-star"
    
        case 'user':
        return "fas fa-user"
    
        case 'film':
        return "fas fa-film"
    
        case 'th-large':
        return "fas fa-th-large"
    
        case 'th':
        return "fas fa-th"
    
        case 'th-list':
        return "fas fa-th-list"
    
        case 'check':
        return "fas fa-check"
    
        case 'remove':
        return "fas fa-times"
    
        case 'close':
        return "fas fa-times"
    
        case 'times':
        return "fas fa-times"
    
        case 'search-plus':
        return "fas fa-search-plus"
    
        case 'search-minus':
        return "fas fa-search-minus"
    
        case 'power-off':
        return "fas fa-power-off"
    
        case 'signal':
        return "fas fa-signal"
    
        case 'gear':
        return "fas fa-cog"
    
        case 'cog':
        return "fas fa-cog"
    
        case 'trash-o':
        return "far fa-trash-alt"
    
        case 'home':
        return "fas fa-home"
    
        case 'file-o':
        return "far fa-file"
    
        case 'clock-o':
        return "far fa-clock"
    
        case 'road':
        return "fas fa-road"
    
        case 'download':
        return "fas fa-download"
    
        case 'arrow-circle-o-down':
        return "far fa-arrow-alt-circle-down"
    
        case 'arrow-circle-o-up':
        return "far fa-arrow-alt-circle-up"
    
        case 'inbox':
        return "fas fa-inbox"
    
        case 'play-circle-o':
        return "far fa-play-circle"
    
        case 'rotate-right':
        return "fas fa-redo"
    
        case 'repeat':
        return "fas fa-redo"
    
        case 'refresh':
        return "fas fa-sync"
    
        case 'list-alt':
        return "far fa-list-alt"
    
        case 'lock':
        return "fas fa-lock"
    
        case 'flag':
        return "fas fa-flag"
    
        case 'headphones':
        return "fas fa-headphones"
    
        case 'volume-off':
        return "fas fa-volume-off"
    
        case 'volume-down':
        return "fas fa-volume-down"
    
        case 'volume-up':
        return "fas fa-volume-up"
    
        case 'qrcode':
        return "fas fa-qrcode"
    
        case 'barcode':
        return "fas fa-barcode"
    
        case 'tag':
        return "fas fa-tag"
    
        case 'tags':
        return "fas fa-tags"
    
        case 'book':
        return "fas fa-book"
    
        case 'bookmark':
        return "fas fa-bookmark"
    
        case 'print':
        return "fas fa-print"
    
        case 'camera':
        return "fas fa-camera"
    
        case 'font':
        return "fas fa-font"
    
        case 'bold':
        return "fas fa-bold"
    
        case 'italic':
        return "fas fa-italic"
    
        case 'text-height':
        return "fas fa-text-height"
    
        case 'text-width':
        return "fas fa-text-width"
    
        case 'align-left':
        return "fas fa-align-left"
    
        case 'align-center':
        return "fas fa-align-center"
    
        case 'align-right':
        return "fas fa-align-right"
    
        case 'align-justify':
        return "fas fa-align-justify"
    
        case 'list':
        return "fas fa-list"
    
        case 'dedent':
        return "fas fa-outdent"
    
        case 'outdent':
        return "fas fa-outdent"
    
        case 'indent':
        return "fas fa-indent"
    
        case 'video-camera':
        return "fas fa-video"
    
        case 'photo':
        return "far fa-image"
    
        case 'image':
        return "far fa-image"
    
        case 'picture-o':
        return "far fa-image"
    
        case 'pencil':
        return "fas fa-pencil-alt"
    
        case 'map-marker':
        return "fas fa-map-marker-alt"
    
        case 'adjust':
        return "fas fa-adjust"
    
        case 'tint':
        return "fas fa-tint"
    
        case 'edit':
        return "far fa-edit"
    
        case 'pencil-square-o':
        return "fas fa-pen-square"
    
        case 'share-square-o':
        return "far fa-share-square"
    
        case 'check-square-o':
        return "far fa-check-square"
    
        case 'arrows':
        return "fas fa-arrows-alt"
    
        case 'step-backward':
        return "fas fa-step-backward"
    
        case 'fast-backward':
        return "fas fa-fast-backward"
    
        case 'backward':
        return "fas fa-backward"
    
        case 'play':
        return "fas fa-play"
    
        case 'pause':
        return "fas fa-pause"
    
        case 'stop':
        return "fas fa-stop"
    
        case 'forward':
        return "fas fa-forward"
    
        case 'fast-forward':
        return "fas fa-fast-forward"
    
        case 'step-forward':
        return "fas fa-step-forward"
    
        case 'eject':
        return "fas fa-eject"
    
        case 'chevron-left':
        return "fas fa-chevron-left"
    
        case 'chevron-right':
        return "fas fa-chevron-right"
    
        case 'plus-circle':
        return "fas fa-plus-circle"
    
        case 'minus-circle':
        return "fas fa-minus-circle"
    
        case 'times-circle':
        return "fas fa-times-circle"
    
        case 'check-circle':
        return "fas fa-check-circle"
    
        case 'question-circle':
        return "fas fa-question-circle"
    
        case 'info-circle':
        return "fas fa-info-circle"
    
        case 'crosshairs':
        return "fas fa-crosshairs"
    
        case 'times-circle-o':
        return "far fa-times-circle"
    
        case 'check-circle-o':
        return "far fa-check-circle"
    
        case 'ban':
        return "fas fa-ban"
    
        case 'arrow-left':
        return "fas fa-arrow-left"
    
        case 'arrow-right':
        return "fas fa-arrow-right"
    
        case 'arrow-up':
        return "fas fa-arrow-up"
    
        case 'arrow-down':
        return "fas fa-arrow-down"
    
        case 'mail-forward':
        return "fas fa-share"
    
        case 'share':
        return "fas fa-share"
    
        case 'expand':
        return "fas fa-expand"
    
        case 'compress':
        return "fas fa-compress"
    
        case 'plus':
        return "fas fa-plus"
    
        case 'minus':
        return "fas fa-minus"
    
        case 'asterisk':
        return "fas fa-asterisk"
    
        case 'exclamation-circle':
        return "fas fa-exclamation-circle"
    
        case 'gift':
        return "fas fa-gift"
    
        case 'leaf':
        return "fas fa-leaf"
    
        case 'fire':
        return "fas fa-fire"
    
        case 'eye':
        return "far fa-eye"
    
        case 'eye-slash':
        return "far fa-eye-slash"
    
        case 'warning':
        return "fas fa-exclamation-triangle"
    
        case 'exclamation-triangle':
        return "fas fa-exclamation-triangle"
    
        case 'plane':
        return "fas fa-plane"
    
        case 'calendar':
        return "fas fa-calendar"
    
        case 'random':
        return "fas fa-random"
    
        case 'comment':
        return "fas fa-comment"
    
        case 'magnet':
        return "fas fa-magnet"
    
        case 'chevron-up':
        return "fas fa-chevron-up"
    
        case 'chevron-down':
        return "fas fa-chevron-down"
    
        case 'retweet':
        return "fas fa-retweet"
    
        case 'shopping-cart':
        return "fas fa-shopping-cart"
    
        case 'folder':
        return "fas fa-folder"
    
        case 'folderOpen':
        return "fas fa-folder-open"
    
        case 'arrows-v':
        return "fas fa-arrows-alt-v"
    
        case 'arrows-h':
        return "fas fa-arrows-alt-h"
    
        case 'bar-chart-o':
        return "far fa-chart-bar"
    
        case 'bar-chart':
        return "fas fa-chart-bar"
    
        case 'twitter-square':
        return "fab fa-twitter-square"
    
        case 'facebook-square':
        return "fab fa-facebook-square"
    
        case 'camera-retro':
        return "fas fa-camera-retro"
    
        case 'key':
        return "fas fa-key"
    
        case 'gears':
        return "fas fa-cogs"
    
        case 'cogs':
        return "fas fa-cogs"
    
        case 'comments':
        return "fas fa-comments"
    
        case 'thumbs-o-up':
        return "far fa-thumbs-up"
    
        case 'thumbs-o-down':
        return "far fa-thumbs-down"
    
        case 'star-half':
        return "fas fa-star-half"
    
        case 'heart-o':
        return "far fa-heart"
    
        case 'sign-out':
        return "fas fa-sign-out-alt"
    
        case 'linkedin-square':
        return "fab fa-linkedin"
    
        case 'thumbTack':
        return "fas fa-thumbtack"
    
        case 'external-link':
        return "fas fa-external-link-alt"
    
        case 'signIn':
        return "fas fa-sign-in-alt"
    
        case 'trophy':
        return "fas fa-trophy"
    
        case 'githubSquare':
        return "fab fa-github-square"
    
        case 'upload':
        return "fas fa-upload"
    
        case 'lemon-o':
        return "far fa-lemon"
    
        case 'phone':
        return "fas fa-phone-alt"
    
        case 'square-o':
        return "far fa-square"
    
        case 'bookmark-o':
        return "far fa-bookmark"
    
        case 'phone-square':
        return "fas fa-phone-square-alt"
    
        case 'twitter':
        return "fab fa-twitter"
    
        case 'facebook-f':
        return "fab fa-facebook-f"
    
        case 'facebook':
        return "fab fa-facebook"
    
        case 'github':
        return "fab fa-github"
    
        case 'unlock':
        return "fas fa-unlock"
    
        case 'credit-card':
        return "far fa-credit-card"
    
        case 'feed':
        return "fas fa-rss"
    
        case 'rss':
        return "fas fa-rss"
    
        case 'hdd-o':
        return "far fa-hdd"
    
        case 'bullhorn':
        return "fas fa-bullhorn"
    
        case 'bell':
        return "fas fa-bell"
    
        case 'certificate':
        return "fas fa-certificate"
    
        case 'hand-o-right':
        return "far fa-hand-point-right"
    
        case 'hand-o-left':
        return "far fa-hand-point-left"
    
        case 'hand-o-up':
        return "far fa-hand-point-up"
    
        case 'hand-o-down':
        return "far fa-hand-point-down"
    
        case 'arrow-circle-left':
        return "fas fa-arrow-circle-left"
    
        case 'arrow-circle-right':
        return "fas fa-arrow-circle-right"
    
        case 'arrow-circle-up':
        return "fas fa-arrow-circle-up"
    
        case 'arrow-circle-down':
        return "fas fa-arrow-circle-down"
    
        case 'globe':
        return "fas fa-globe"
    
        case 'wrench':
        return "fas fa-wrench"
    
        case 'tasks':
        return "fas fa-tasks"
    
        case 'filter':
        return "fas fa-filter"
    
        case 'briefcase':
        return "fas fa-briefcase"
    
        case 'arrows-alt':
        return "fas fa-expand-arrows-alt"
    
        case 'group':
        return "fas fa-users"
    
        case 'users':
        return "fas fa-users"
    
        case 'chain':
        return "fas fa-link"
    
        case 'link':
        return "fas fa-link"
    
        case 'cloud':
        return "fas fa-cloud"
    
        case 'flask':
        return "fas fa-flask"
    
        case 'cut':
        return "fas fa-cut"
    
        case 'scissors':
        return "fas fa-cut"
    
        case 'copy':
        return "far fa-copy"
    
        case 'files-o':
        return "far fa-copy"
    
        case 'paperclip':
        return "fas fa-paperclip"
    
        case 'save':
        return "far fa-save"
    
        case 'floppy-o':
        return "far fa-save"
    
        case 'square':
        return "fas fa-square"
    
        case 'navicon':
        return "fas fa-bars"
    
        case 'reorder':
        return "fas fa-bars"
    
        case 'bars':
        return "fas fa-bars"
    
        case 'list-ul':
        return "fas fa-list-ul"
    
        case 'list-ol':
        return "fas fa-list-ol"
    
        case 'strikethrough':
        return "fas fa-strikethrough"
    
        case 'underline':
        return "fas fa-underline"
    
        case 'table':
        return "fas fa-table"
    
        case 'magic':
        return "fas fa-magic"
    
        case 'truck':
        return "fas fa-truck"
    
        case 'pinterest':
        return "fab fa-pinterest"
    
        case 'pinterest-square':
        return "fab fa-pinterest-square"
    
        case 'google-plus-square':
        return "fab fa-google-plus-square"
    
        case 'google-plus':
        return "fab fa-google-plus"
    
        case 'money':
        return "far fa-money-bill-alt"
    
        case 'caret-down':
        return "fas fa-caret-down"
    
        case 'caret-up':
        return "fas fa-caret-up"
    
        case 'caret-left':
        return "fas fa-caret-left"
    
        case 'caret-right':
        return "fas fa-caret-right"
    
        case 'columns':
        return "fas fa-columns"
    
        case 'unsorted':
        return "fas fa-sort"
    
        case 'sort':
        return "fas fa-sort"
    
        case 'sort-down':
        return "fas fa-sort-down"
    
        case 'sort-desc':
        return "fas fa-sort-down"
    
        case 'sort-up':
        return "fas fa-sort-up"
    
        case 'sort-asc':
        return "fas fa-sort-up"
    
        case 'envelope':
        return "fas fa-envelope"
    
        case 'linkedin':
        return "fab fa-linkedin"
    
        case 'rotate-left':
        return "fas fa-undo"
    
        case 'undo':
        return "fas fa-undo"
    
        case 'legal':
        return "fas fa-gavel"
    
        case 'gavel':
        return "fas fa-gavel"
    
        case 'dashboard':
        return "fas fa-tachometer-alt"
    
        case 'tachometer':
        return "fas fa-tachometer-alt"
    
        case 'comment-o':
        return "far fa-comment"
    
        case 'comments-o':
        return "far fa-comments"
    
        case 'flash':
        return "fas fa-bolt"
    
        case 'bolt':
        return "fas fa-bolt"
    
        case 'sitemap':
        return "fas fa-sitemap"
    
        case 'umbrella':
        return "fas fa-umbrella"
    
        case 'paste':
        return "fas fa-paste"
    
        case 'clipboard':
        return "far fa-clipboard"
    
        case 'lightbulb-o':
        return "far fa-lightbulb"
    
        case 'exchange':
        return "fas fa-exchange-alt"
    
        case 'cloud-download':
        return "fas fa-cloud-download-alt"
    
        case 'cloud-upload':
        return "fas fa-cloud-upload-alt"
    
        case 'user-md':
        return "fas fa-user-md"
    
        case 'stethoscope':
        return "fas fa-stethoscope"
    
        case 'suitcase':
        return "fas fa-suitcase"
    
        case 'bell-o':
        return "far fa-bell"
    
        case 'coffee':
        return "fas fa-coffee"
    
        case 'cutlery':
        return "fas fa-utensils"
    
        case 'file-text-o':
        return "far fa-file-alt"
    
        case 'building-o':
        return "far fa-building"
    
        case 'hospital-o':
        return "far fa-hospital"
    
        case 'ambulance':
        return "fas fa-ambulance"
    
        case 'medkit':
        return "fas fa-medkit"
    
        case 'fighter-jet':
        return "fas fa-fighter-jet"
    
        case 'beer':
        return "fas fa-beer"
    
        case 'h-square':
        return "fas fa-h-square"
    
        case 'plus-square':
        return "fas fa-plus-square"
    
        case 'angle-double-left':
        return "fas fa-angle-double-left"
    
        case 'angle-double-right':
        return "fas fa-angle-double-right"
    
        case 'angle-double-up':
        return "fas fa-angle-double-up"
    
        case 'angle-double-down':
        return "fas fa-angle-double-down"
    
        case 'angle-left':
        return "fas fa-angle-left"
    
        case 'angle-right':
        return "fas fa-angle-right"
    
        case 'angle-up':
        return "fas fa-angle-up"
    
        case 'angle-down':
        return "fas fa-angle-down"
    
        case 'desktop':
        return "fas fa-desktop"
    
        case 'laptop':
        return "fas fa-laptop"
    
        case 'tablet':
        return "fas fa-tablet-alt"
    
        case 'mobile-phone':
        return "fas fa-mobile-alt"
    
        case 'mobile':
        return "fas fa-mobile-alt"
    
        case 'circle-o':
        return "far fa-circle"
    
        case 'quote-left':
        return "fas fa-quote-left"
    
        case 'quote-right':
        return "fas fa-quote-right"
    
        case 'spinner':
        return "fas fa-spinner"
    
        case 'circle':
        return "fas fa-circle"
    
        case 'mail-reply':
        return "fas fa-reply"
    
        case 'reply':
        return "fas fa-reply"
    
        case 'github-alt':
        return "fab fa-github-alt"
    
        case 'folder-o':
        return "far fa-folder"
    
        case 'folder-open-o':
        return "far fa-folder-open"
    
        case 'smile-o':
        return "far fa-smile"
    
        case 'frown-o':
        return "far fa-frown"
    
        case 'meh-o':
        return "far fa-meh"
    
        case 'gamepad':
        return "fas fa-gamepad"
    
        case 'keyboard-o':
        return "far fa-keyboard"
    
        case 'flag-o':
        return "far fa-flag"
    
        case 'flag-checkered':
        return "fas fa-flag-checkered"
    
        case 'terminal':
        return "fas fa-terminal"
    
        case 'code':
        return "fas fa-code"
    
        case 'mail-reply-all':
        return "fas fa-reply-all"
    
        case 'reply-all':
        return "fas fa-reply-all"
    
        case 'star-half-empty':
        return "fas fa-star-half-alt"
    
        case 'star-half-full':
        return "fas fa-star-half-alt"
    
        case 'star-half-o':
        return "fas fa-star-half-alt"
    
        case 'location-arrow':
        return "fas fa-location-arrow"
    
        case 'crop':
        return "fas fa-crop"
    
        case 'code-fork':
        return "fas fa-code-branch"
    
        case 'unlink':
        return "fas fa-unlink"
    
        case 'chain-broken':
        return "fas fa-unlink"
    
        case 'question':
        return "fas fa-question"
    
        case 'info':
        return "fas fa-info"
    
        case 'exclamation':
        return "fas fa-exclamation"
    
        case 'superscript':
        return "fas fa-superscript"
    
        case 'subscript':
        return "fas fa-subscript"
    
        case 'eraser':
        return "fas fa-eraser"
    
        case 'puzzle-piece':
        return "fas fa-puzzle-piece"
    
        case 'microphone':
        return "fas fa-microphone"
    
        case 'microphone-slash':
        return "fas fa-microphone-slash"
    
        case 'shield':
        return "fas fa-shield-alt"
    
        case 'calendarO':
        return "far fa-calendar"
    
        case 'fire-extinguisher':
        return "fas fa-fire-extinguisher"
    
        case 'rocket':
        return "fas fa-rocket"
    
        case 'maxcdn':
        return "fab fa-maxcdn"
    
        case 'chevron-circle-left':
        return "fas fa-chevron-circle-left"
    
        case 'chevron-circle-right':
        return "fas fa-chevron-circle-right"
    
        case 'chevron-circle-up':
        return "fas fa-chevron-circle-up"
    
        case 'chevron-circle-down':
        return "fas fa-chevron-circle-down"
    
        case 'html5':
        return "fab fa-html5"
    
        case 'css3':
        return "fab fa-css3"
    
        case 'anchor':
        return "fas fa-anchor"
    
        case 'unlock-alt':
        return "fas fa-unlock-alt"
    
        case 'bullseye':
        return "fas fa-bullseye"
    
        case 'ellipsis-h':
        return "fas fa-ellipsis-h"
    
        case 'ellipsis-v':
        return "fas fa-ellipsis-v"
    
        case 'rss-square':
        return "fas fa-rss-square"
    
        case 'play-circle':
        return "fas fa-play-circle"
    
        case 'ticket':
        return "fas fa-ticket-alt"
    
        case 'minus-square':
        return "fas fa-minus-square"
    
        case 'minus-square-o':
        return "far fa-minus-square"
    
        case 'level-up':
        return "fas fa-level-up-alt"
    
        case 'level-down':
        return "fas fa-level-down-alt"
    
        case 'check-square':
        return "fas fa-check-square"
    
        case 'pencil-square':
        return "fas fa-pencil-square"
    
        case 'external-link-square':
        return "fas fa-external-link-square-alt"
    
        case 'share-square':
        return "fas fa-share-square"
    
        case 'compass':
        return "far fa-compass"
    
        case 'turkish-lira':
        return "fas fa-lira-sign"
    
        case 'meanpath':
        return "fab fa-font-awesome"
    
        case 'try':
        return "fas fa-lira-sign"
    
        case 'caret-square-o-down':
        return "far fa-caret-square-down"
    
        case 'toggle-up':
        return "far fa-caret-square-up"
    
        case 'caret-square-o-up':
        return "far fa-caret-square-up"
    
        case 'toggle-right':
        return "far fa-caret-square-right"
    
        case 'caret-square-o-right':
        return "far fa-caret-square-right"
    
        case 'euro':
        return "fas fa-euro-sign"
    
        case 'eur':
        return "fas fa-euro-sign"
    
        case 'gbp':
        return "fas fa-pound-sign"
    
        case 'dollar':
        return "fas fa-dollar-sign"
    
        case 'usd':
        return "fas fa-dollar-sign"
    
        case 'rupee':
        return "fas fa-rupee-sign"
    
        case 'inr':
        return "fas fa-rupee-sign"
    
        case 'cny':
        return "fas fa-yen-sign"
    
        case 'rmb':
        return "fas fa-yen-sign"
    
        case 'yen':
        return "fas fa-yen-sign"
    
        case 'jpy':
        return "fas fa-yen-sign"
    
        case 'ruble':
        return "fas fa-ruble-sign"
    
        case 'rouble':
        return "fas fa-ruble-sign"
    
        case 'rub':
        return "fas fa-ruble-sign"
    
        case 'won':
        return "fas fa-won-sign"
    
        case 'krw':
        return "fas fa-won-sign"
    
        case 'bitcoin':
        return "fab fa-bitcoin"
    
        case 'btc':
        return "fab fa-bitcoin"
    
        case 'file':
        return "fas fa-file"
    
        case 'fileText':
        return "fas fa-file-alt"
    
        case 'sort-alpha-asc':
        return "fas fa-sort-alpha-down"
    
        case 'sort-alpha-desc':
        return "fas fa-sort-alpha-alt"
    
        case 'sort-amount-asc':
        return "fas fa-sort-amount-down-alt"
    
        case 'sort-amount-desc':
        return "fas fa-sort-amount-down"
    
        case 'sort-numeric-asc':
        return "fas fa-sort-numeric-down"
    
        case 'sort-numeric-desc':
        return "fas fa-sort-numeric-alt"
    
        case 'thumbs-up':
        return "fas fa-thumbs-up"
    
        case 'thumbs-down':
        return "fas fa-thumbs-down"
    
        case 'youtube-square':
        return "fab fa-youtube-square"
    
        case 'youtube':
        return "fab fa-youtube"
    
        case 'xing':
        return "fab fa-xing"
    
        case 'xing-square':
        return "fab fa-xing-square"
    
        case 'youtube-play':
        return "fab fa-youtube"
    
        case 'dropbox':
        return "fab fa-dropbox"
    
        case 'stack-overflow':
        return "fab fa-stack-overflow"
    
        case 'instagram':
        return "fab fa-instagram"
    
        case 'flickr':
        return "fab fa-flickr"
    
        case 'adn':
        return "fab fa-adn"
    
        case 'bitbucket':
        return "fab fa-bitbucket"
    
        case 'bitbucket-square':
        return "fab fa-bitbucket"
    
        case 'tumblr':
        return "fab fa-tumblr"
    
        case 'tumblr-square':
        return "fab fa-tumblr-square"
    
        case 'long-arrow-down':
        return "fas fa-long-arrow-alt-down"
    
        case 'long-arrow-up':
        return "fas fa-long-arrow-alt-up"
    
        case 'long-arrow-left':
        return "fas fa-long-arrow-alt-left"
    
        case 'long-arrow-right':
        return "fas fa-long-arrow-alt-right"
    
        case 'apple':
        return "fab fa-apple"
    
        case 'windows':
        return "fab fa-windows"
    
        case 'android':
        return "fab fa-android"
    
        case 'linux':
        return "fab fa-linux"
    
        case 'dribbble':
        return "fab fa-dribbble"
    
        case 'skype':
        return "fab fa-skype"
    
        case 'foursquare':
        return "fab fa-foursquare"
    
        case 'trello':
        return "fab fa-trello"
    
        case 'female':
        return "fas fa-female"
    
        case 'male':
        return "fas fa-male"
    
        case 'gittip':
        return "fab fa-gratipay"
    
        case 'gratipay':
        return "fab fa-gratipay"
    
        case 'sun-o':
        return "far fa-sun"
    
        case 'moon-o':
        return "far fa-moon"
    
        case 'archive':
        return "fas fa-archive"
    
        case 'bug':
        return "fas fa-bug"
    
        case 'vk':
        return "fab fa-vk"
    
        case 'weibo':
        return "fab fa-weibo"
    
        case 'renren':
        return "fab fa-renren"
    
        case 'pagelines':
        return "fab fa-pagelines"
    
        case 'stack-exchange':
        return "fab fa-stack-exchange"
    
        case 'arrow-circle-o-right':
        return "far fa-arrow-alt-circle-right"
    
        case 'arrow-circle-o-left':
        return "far fa-arrow-alt-circle-left"
    
        case 'caret-square-o-left':
        return "far fa-caret-square-left"
    
        case 'dot-circle-o':
        return "far fa-dot-circle"
    
        case 'wheelchair':
        return "fas fa-wheelchair"
    
        case 'vimeo-square':
        return "fab fa-vimeo-square"
    
        case 'plus-square-o':
        return "far fa-plus-square"
    
        case 'space-shuttle':
        return "fas fa-space-shuttle"
    
        case 'slack':
        return "fab fa-slack"
    
        case 'envelope-square':
        return "fas fa-envelope-square"
    
        case 'wordpress':
        return "fab fa-wordpress"
    
        case 'openid':
        return "fab fa-openid"
    
        case 'institution':
        return "fas fa-university"
    
        case 'bank':
        return "fas fa-university"
    
        case 'university':
        return "fas fa-university"
    
        case 'mortar-board':
        return "fas fa-graduation-cap"
    
        case 'graduation-cap':
        return "fas fa-graduation-cap"
    
        case 'yahoo':
        return "fab fa-yahoo"
    
        case 'google':
        return "fab fa-google"
    
        case 'reddit':
        return "fab fa-reddit"
    
        case 'reddit-square':
        return "fab fa-reddit-square"
    
        case 'stumbleupon-circle':
        return "fab fa-stumbleupon-circle"
    
        case 'stumbleupon':
        return "fab fa-stumbleupon"
    
        case 'delicious':
        return "fab fa-delicious"
    
        case 'digg':
        return "fab fa-digg"
    
        case 'pied-piper':
        return "fab fa-pied-piper"
    
        case 'pied-piper-alt':
        return "fab fa-pied-piper-alt"
    
        case 'drupal':
        return "fab fa-drupal"
    
        case 'joomla':
        return "fab fa-joomla"
    
        case 'language':
        return "fas fa-language"
    
        case 'fax':
        return "fas fa-fax"
    
        case 'building':
        return "fas fa-building"
    
        case 'child':
        return "fas fa-child"
    
        case 'paw':
        return "fas fa-paw"
    
        case 'spoon':
        return "fas fa-spoon"
    
        case 'cube':
        return "fas fa-cube"
    
        case 'cubes':
        return "fas fa-cubes"
    
        case 'behance':
        return "fab fa-behance"
    
        case 'behance-square':
        return "fab fa-behance-square"
    
        case 'steam':
        return "fab fa-steam"
    
        case 'steam-square':
        return "fab fa-steam-square"
    
        case 'recycle':
        return "fas fa-recycle"
    
        case 'automobile':
        return "fas fa-car-alt"
    
        case 'car':
        return "fas fa-car-alt"
    
        case 'cab':
        return "fas fa-taxi"
    
        case 'taxi':
        return "fas fa-taxi"
    
        case 'tree':
        return "fas fa-tree"
    
        case 'spotify':
        return "fab fa-spotify"
    
        case 'deviantart':
        return "fab fa-deviantart"
    
        case 'soundcloud':
        return "fab fa-soundcloud"
    
        case 'database':
        return "fas fa-database"
    
        case 'file-pdf-o':
        return "far fa-file-pdf"
    
        case 'file-word-o':
        return "far fa-file-word"
    
        case 'file-excel-o':
        return "far fa-file-excel"
    
        case 'file-powerpoint-o':
        return "far fa-file-powerpoint"
    
        case 'file-photo-o':
        return "far fa-file-image"
    
        case 'file-picture-o':
        return "far fa-file-image"
    
        case 'file-image-o':
        return "far fa-file-image"
    
        case 'file-zip-o':
        return "far fa-file-archive"
    
        case 'file-archive-o':
        return "far fa-file-archive"
    
        case 'file-sound-o':
        return "far fa-file-audio"
    
        case 'file-audio-o':
        return "far fa-file-audio"
    
        case 'file-movie-o':
        return "far fa-file-video"
    
        case 'file-video-o':
        return "far fa-file-video"
    
        case 'file-code-o':
        return "far fa-file-code"
    
        case 'vine':
        return "fab fa-vine"
    
        case 'codepen':
        return "fab fa-codepen"
    
        case 'jsfiddle':
        return "fab fa-jsfiddle"
    
        case 'life-bouy':
        return "far fa-life-ring"
    
        case 'life-buoy':
        return "far fa-life-ring"
    
        case 'life-saver':
        return "far fa-life-ring"
    
        case 'support':
        return "far fa-life-ring"
    
        case 'life-ring':
        return "far fa-life-ring"
    
        case 'circle-o-notch':
        return "fas fa-circle-notch"
    
        case 'ra':
        return "fab fa-rebel"
    
        case 'rebel':
        return "fab fa-rebel"
    
        case 'ge':
        return "fab fa-empire"
    
        case 'empire':
        return "fab fa-empire"
    
        case 'gitSquare':
        return "fab fa-git-square"
    
        case 'git':
        return "fab fa-git"
    
        case 'y-combinator-square':
        return "fab fa-y-combinator"
    
        case 'yc-square':
        return "fab fa-y-combinator"
    
        case 'hacker-news':
        return "fab fa-hacker-news"
    
        case 'tencent-weibo':
        return "fab fa-tencent-weibo"
    
        case 'qq':
        return "fab fa-qq"
    
        case 'wechat':
        return "fab fa-wechat"
    
        case 'weixin':
        return "fab fa-weixin"
    
        case 'send':
        return "fas fa-paper-plane"
    
        case 'paper-plane':
        return "fas fa-paper-plane"
    
        case 'send-o':
        return "far fa-paper-plane"
    
        case 'paper-plane-o':
        return "far fa-paper-plane"
    
        case 'history':
        return "fas fa-history"
    
        case 'circle-thin':
        return "far fa-circle"
    
        case 'header':
        return "fas fa-heading"
    
        case 'paragraph':
        return "fas fa-paragraph"
    
        case 'sliders':
        return "fas fa-sliders-h"
    
        case 'share-alt':
        return "fas fa-share-alt"
    
        case 'share-alt-square':
        return "fas fa-share-alt-square"
    
        case 'bomb':
        return "fas fa-bomb"
    
        case 'soccer-ball-o':
        return "far fa-futbol"
    
        case 'futbol-o':
        return "far fa-futbol"
    
        case 'tty':
        return "fas fa-tty"
    
        case 'binoculars':
        return "fas fa-binoculars"
    
        case 'plug':
        return "fas fa-plug"
    
        case 'slideshare':
        return "fab fa-slideshare"
    
        case 'twitch':
        return "fab fa-twitch"
    
        case 'yelp':
        return "fab fa-yelp"
    
        case 'newspaper-o':
        return "far fa-newspaper"
    
        case 'wifi':
        return "fas fa-wifi"
    
        case 'calculator':
        return "fas fa-calculator"
    
        case 'paypal':
        return "fab fa-paypal"
    
        case 'google-wallet':
        return "fab fa-google-wallet"
    
        case 'cc-visa':
        return "fab fa-cc-visa"
    
        case 'cc-mastercard':
        return "fab fa-cc-mastercard"
    
        case 'cc-discover':
        return "fab fa-cc-discover"
    
        case 'cc-amex':
        return "fab fa-cc-amex"
    
        case 'cc-paypal':
        return "fab fa-cc-paypal"
    
        case 'cc-stripe':
        return "fab fa-cc-stripe"
    
        case 'bell-slash':
        return "fas fa-bell-slash"
    
        case 'bell-slash-o':
        return "far fa-bell-slash"
    
        case 'trash':
        return "fas fa-trash-alt"
    
        case 'copyright':
        return "far fa-copyright"
    
        case 'at':
        return "fas fa-at"
    
        case 'eyedropper':
        return "fas fa-eye-dropper"
    
        case 'paint-brush':
        return "fas fa-paint-brush"
    
        case 'birthday-cake':
        return "fas fa-birthday-cake"
    
        case 'area-chart':
        return "fas fa-chart-area"
    
        case 'pie-chart':
        return "fas fa-chart-pie"
    
        case 'line-chart':
        return "fas fa-chart-line"
    
        case 'lastfm':
        return "fab fa-lastfm"
    
        case 'lastfm-square':
        return "fab fa-lastfm-square"
    
        case 'toggle-off':
        return "fas fa-toggle-off"
    
        case 'toggle-on':
        return "fas fa-toggle-on"
    
        case 'bicycle':
        return "fas fa-bicycle"
    
        case 'bus':
        return "fas fa-bus"
    
        case 'ioxhost':
        return "fab fa-ioxhost"
    
        case 'angellist':
        return "fab fa-angellist"
    
        case 'cc':
        return "far fa-closed-captioning"
    
        case 'shekel':
        return "fas fa-shekel-sign"
    
        case 'sheqel':
        return "fas fa-shekel-sign"
    
        case 'ils':
        return "fas fa-shekel-sign"
    
        case 'buysellads':
        return "fab fa-buysellads"
    
        case 'connectdevelop':
        return "fab fa-connectdevelop"
    
        case 'dashcube':
        return "fab fa-dashcube"
    
        case 'forumbee':
        return "fab fa-forumbee"
    
        case 'leanpub':
        return "fab fa-leanpub"
    
        case 'sellsy':
        return "fab fa-sellsy"
    
        case 'shirtsinbulk':
        return "fab fa-shirtsinbulk"
    
        case 'simplybuilt':
        return "fab fa-simplybuilt"
    
        case 'skyatlas':
        return "fab fa-skyatlas"
    
        case 'cart-plus':
        return "fas fa-cart-plus"
    
        case 'cart-arrow-down':
        return "fas fa-cart-arrow-down"
    
        case 'diamond':
        return "far fa-gem"
    
        case 'ship':
        return "fas fa-ship"
    
        case 'user-secret':
        return "fas fa-user-secret"
    
        case 'motorcycle':
        return "fas fa-motorcycle"
    
        case 'street-view':
        return "fas fa-street-view"
    
        case 'heartbeat':
        return "fas fa-heartbeat"
    
        case 'venus':
        return "fas fa-venus"
    
        case 'mars':
        return "fas fa-mars"
    
        case 'mercury':
        return "fas fa-mercury"
    
        case 'intersex':
        return "fas fa-transgender"
    
        case 'transgender':
        return "fas fa-transgender"
    
        case 'transgender-alt':
        return "fas fa-transgender-alt"
    
        case 'venus-double':
        return "fas fa-venus-double"
    
        case 'mars-double':
        return "fas fa-mars-double"
    
        case 'venus-mars':
        return "fas fa-venus-mars"
    
        case 'mars-stroke':
        return "fas fa-mars-stroke"
    
        case 'mars-stroke-v':
        return "fas fa-mars-stroke-v"
    
        case 'mars-stroke-h':
        return "fas fa-mars-stroke-h"
    
        case 'neuter':
        return "fas fa-neuter"
    
        case 'genderless':
        return "fas fa-genderless"
    
        case 'facebook-official':
        return "fab fa-facebook"
    
        case 'pinterest-p':
        return "fab fa-pinterest-p"
    
        case 'whatsapp':
        return "fab fa-whatsapp"
    
        case 'server':
        return "fas fa-server"
    
        case 'user-plus':
        return "fas fa-user-plus"
    
        case 'user-times':
        return "fas fa-user-times"
    
        case 'hotel':
        return "fas fa-hotel"
    
        case 'bed':
        return "fas fa-bed"
    
        case 'viacoin':
        return "fab fa-viacoin"
    
        case 'train':
        return "fas fa-train"
    
        case 'subway':
        return "fas fa-subway"
    
        case 'medium':
        return "fab fa-medium"
    
        case 'yc':
        return "fab fa-y-combinator"
    
        case 'y-combinator':
        return "fab fa-y-combinator"
    
        case 'optin-monster':
        return "fab fa-optin-monster"
    
        case 'opencart':
        return "fab fa-opencart"
    
        case 'expeditedssl':
        return "fab fa-expeditedssl"
    
        case 'battery-4':
        return "fas fa-battery-full"
    
        case 'battery-full':
        return "fas fa-battery-full"
    
        case 'battery-3':
        return "fas fa-battery-three-quarters"
    
        case 'battery-three-quarters':
        return "fas fa-battery-three-quarters"
    
        case 'battery-2':
        return "fas fa-battery-half"
    
        case 'battery-half':
        return "fas fa-battery-half"
    
        case 'battery-1':
        return "fas fa-battery-quarter"
    
        case 'battery-quarter':
        return "fas fa-battery-quarter"
    
        case 'battery-0':
        return "fas fa-battery-empty"
    
        case 'battery-empty':
        return "fas fa-battery-empty"
    
        case 'mouse-pointer':
        return "fas fa-mouse-pointer"
    
        case 'i-cursor':
        return "fas fa-i-cursor"
    
        case 'object-group':
        return "far fa-object-group"
    
        case 'object-ungroup':
        return "far fa-object-ungroup"
    
        case 'sticky-note':
        return "fas fa-sticky-note"
    
        case 'sticky-note-o':
        return "far fa-sticky-note"
    
        case 'cc-jcb':
        return "fab fa-cc-jcb"
    
        case 'cc-diners-club':
        return "fab fa-cc-diners-club"
    
        case 'clone':
        return "far fa-clone"
    
        case 'balance-scale':
        return "fas fa-balance-scale"
    
        case 'hourglass-o':
        return "far fa-hourglass"
    
        case 'hourglass-1':
        return "fas fa-hourglass-start"
    
        case 'hourglass-start':
        return "fas fa-hourglass-start"
    
        case 'hourglass-2':
        return "fas fa-hourglass-half"
    
        case 'hourglass-half':
        return "fas fa-hourglass-start"
    
        case 'hourglass-3':
        return "fas fa-hourglass-end"
    
        case 'hourglass-end':
        return "fas fa-hourglass-start"
    
        case 'hourglass':
        return "fas fa-hourglass"
    
        case 'hand-grab-o':
        return "far fa-hand-rock"
    
        case 'hand-rock-o':
        return "far fa-hand-rock"
    
        case 'hand-stop-o':
        return "far fa-hand-paper"
    
        case 'hand-paper-o':
        return "far fa-hand-paper"
    
        case 'hand-scissors-o':
        return "far fa-hand-scissors"
    
        case 'hand-lizard-o':
        return "far fa-hand-lizard"
    
        case 'hand-spock-o':
        return "far fa-hand-spock"
    
        case 'hand-pointer-o':
        return "far fa-hand-pointer"
    
        case 'hand-peace-o':
        return "far fa-hand-peace"
    
        case 'trademark':
        return "fas fa-trademark"
    
        case 'registered':
        return "far fa-registered"
    
        case 'creative-commons':
        return "fab fa-creative-commons"
    
        case 'gg':
        return "fab fa-gg"
    
        case 'gg-circle':
        return "fab fa-gg-circle"
    
        case 'tripadvisor':
        return "fab fa-tripadvisor"
    
        case 'odnoklassniki':
        return "fab fa-odnoklassniki"
    
        case 'odnoklassniki-square':
        return "fab fa-odnoklassniki-square"
    
        case 'get-pocket':
        return "fab fa-get-pocket"
    
        case 'wikipedia-w':
        return "fab fa-wikipedia-w"
    
        case 'safari':
        return "fab fa-safari"
    
        case 'chrome':
        return "fab fa-chrome"
    
        case 'firefox':
        return "fab fa-firefox"
    
        case 'opera':
        return "fab fa-opera"
    
        case 'internet-explorer':
        return "fab fa-internet-explorer"
    
        case 'tv':
        return "fas fa-tv"
    
        case 'television':
        return "fas fa-tv"
    
        case 'contao':
        return "fab fa-contao"
    
        case 'px':
        return "fas fa-question"
    
        case 'amazon':
        return "fab fa-amazon"
    
        case 'calendar-plus-o':
        return "far fa-calendar-plus"
    
        case 'calendar-minus-o':
        return "far fa-calendar-minus"
    
        case 'calendar-times-o':
        return "far fa-calendar-times"
    
        case 'calendar-check-o':
        return "far fa-calendar-check"
    
        case 'industry':
        return "fas fa-industry"
    
        case 'map-pin':
        return "fas fa-map-pin"
    
        case 'map-signs':
        return "fas fa-map-signs"
    
        case 'map-o':
        return "far fa-map"
    
        case 'map':
        return "fas fa-map"
    
        case 'commenting':
        return "fas fa-comment-dots"

        case 'commenting-o':
        return "far fa-comment-dots"

        case 'houzz':
        return "fab fa-houzz"

        case 'vimeo':
        return "fab fa-vimeo"

        case 'black-tie':
        return "fab fa-black-tie"

        case 'fonticons':
        return "fab fa-fonticons"

        default:
        return "fas fa-question"
    }
}